module.exports = __webpack_public_path__ + "static/73-percent-graphic.f40f40b6.png";